import { linenedges as actionType } from './actionTypes';
import ExternalServices from '../../services/externalServices';

export const fetchAllArticles = () => async(dispatch) => {
  await dispatch(initLoader(true));
  const articles = await ExternalServices.getAllArticles();
  dispatch({
    type: actionType.FETCH_ALL_ARTICLES,
    payload: articles
  });
  await dispatch(initLoader(false));
};

export const fetchLatestArticles = () => async(dispatch) => {
  await dispatch(initLoader(true));
  const articles = await ExternalServices.getLatestArticles();
  dispatch({
    type: actionType.FETCH_LATEST_ARTICLES,
    payload: articles
  });
  await dispatch(initLoader(false));
};

export const fetchArticleById = (articleId) => async(dispatch) => {
  await dispatch(initLoader(true));
  const article = await ExternalServices.getArticleById(articleId);
  dispatch({
    type: actionType.FETCH_AN_ARTICLE,
    payload: article
  });
  await dispatch(initLoader(false));
}

export const fetchRelatedArticlesByTag = (tags) => async(dispatch) => {
  await dispatch(initLoader(true));
  const article = await ExternalServices.getRelatedArticlesByTag(tags);
  dispatch({
    type: actionType.FETCH_RELATED_ARTICLES,
    payload: article
  });
  await dispatch(initLoader(false));
}

// case studies
export const fetchAllCaseStudies = () => async(dispatch) => {
  await dispatch(initLoader(true));
  const caseStudies = await ExternalServices.getAllCaseStudies();
  dispatch({
    type: actionType.FETCH_ALL_CASESTUDIES,
    payload: caseStudies
  });
  await dispatch(initLoader(false));
}

export const fetchLatestCaseStudies = () => async(dispatch) => {
  await dispatch(initLoader(true));
  const articles = await ExternalServices.getLatestCaseStudies();
  dispatch({
    type: actionType.FETCH_LATEST_CASESTUDIES,
    payload: articles
  });
  await dispatch(initLoader(false));
}

export const fetchCaseStudyById = (articleId) => async(dispatch) => {
  await dispatch(initLoader(true));
  const article = await ExternalServices.getCaseStudyById(articleId);
  dispatch({
    type: actionType.FETCH_A_CASESTUDY,
    payload: article
  });
  await dispatch(initLoader(false));
}

export const initLoader = (status) => async (dispatch) => {
  dispatch({
    type: actionType.APP_LOADING,
    payload: status
  });
}